module.exports = __webpack_public_path__ + "static/media/43.8e681ece.jpg";